import { GET_CUSTOMER_FAULT_IMAGE, GET_CUSTOMER_STATUS_FAULT } from './types';

export function getCustomerStatusFaults(payload) {
  return {
    type: GET_CUSTOMER_STATUS_FAULT,
    payload:payload
  }
}

export function getCustomerFaultsImage(filePath) {
  return {
    type: GET_CUSTOMER_FAULT_IMAGE,
    payload: filePath
  }
}

export function clearAll() {
  return {
    type: GET_CUSTOMER_FAULT_IMAGE,
  }
}